export default __webpack_public_path__ + "static/media/yellow-gradient-box.c692e1f5.svg";